import Select from 'react-select';
import { FieldWrapper } from './FieldWrapper';

export const ReactSelectField = (props) => {
  const {
    label,
    options,
    error,
    setValue,
    name,
    onInputChange,
    required,
    defaultValue,
    onChange,
    onMenuClose,
    isMulti = false,
  } = props;

  // Handle selection
  const onSelectStateChange = (selectState) => {
    setValue(name, selectState ? selectState.value : null);
    if (onChange) {
      onChange(selectState);
    }
  };

  // Glassmorphic style overrides
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      backdropFilter: 'blur(8px)',
      border: state.isFocused
        ? '1px solid rgba(255, 255, 255, 0.3)'
        : '1px solid rgba(255, 255, 255, 0.15)',
      boxShadow: state.isFocused ? '0 0 0 1px rgba(255, 255, 255, 0.3)' : 'none',
      borderRadius: '0.75rem',
      padding: '2px',
      color: '#fff',
      transition: 'all 0.2s ease-in-out',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'rgba(255,255,255,0.5)',
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'rgba(20, 20, 30, 0.6)',
      backdropFilter: 'blur(6px)',
      borderRadius: '0.75rem',
      overflow: 'hidden',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? 'rgba(255,255,255,0.1)'
        : 'transparent',
      color: '#fff',
      padding: '10px 12px',
      cursor: 'pointer',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    input: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: 'rgba(255,255,255,0.1)',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#fff',
      ':hover': {
        backgroundColor: 'rgba(255,255,255,0.2)',
        color: '#fff',
      },
    }),
  };

  return (
    <FieldWrapper label={label} error={error}>
      <Select
        className="basic-single"
        classNamePrefix="select"
        isClearable
        isSearchable
        onMenuClose={onMenuClose}
        name={name}
        required={required}
        isMulti={isMulti}
        onInputChange={onInputChange}
        defaultValue={defaultValue}
        options={options}
        onChange={onSelectStateChange}
        styles={customStyles}
        maxMenuHeight={150}
      />
    </FieldWrapper>
  );
};
